import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ModalState = {
    showExitModal: boolean,
    showPrescriptionModal:boolean,
    showPrescriptionModalInfo: boolean,
    showPrescriptionModalPD: boolean,
    showPrescriptionModalContinue: boolean,
    urlPrescriptionModal:string,
    openPrescriptionInputModal: boolean,
    learnMoreIds?:string[],
    learnMoreFocus?:string
}

const initialState: ModalState = {
    showExitModal: false,
    showPrescriptionModal:false,
    showPrescriptionModalInfo: false,
    showPrescriptionModalPD: false,
    showPrescriptionModalContinue: false,
    urlPrescriptionModal:null,
    openPrescriptionInputModal: false,
};

const modalsSlice = createSlice({
    name: 'modals',
    initialState: initialState,
    reducers: {
        setShowExitModal: (state,{payload}: PayloadAction<boolean>) => {
            state.showExitModal = payload;
        },
        setPrescriptionModal :(state,{payload}:PayloadAction<{show:boolean,url?:string}>)=>{
            state.showPrescriptionModal=payload.show;
            if(payload.show){
                state.urlPrescriptionModal=payload.url;
            }else{
                state.urlPrescriptionModal=null;
            }
        },
        setShowPrescriptionModalInfo: (state,{payload}: PayloadAction<boolean>) => {
            state.showPrescriptionModalInfo = payload;
        },
        setShowPrescriptionModalPD: (state,{payload}: PayloadAction<boolean>) => {
            state.showPrescriptionModalPD = payload;
        },
        setShowPrescriptionModalContinue: (state,{payload}: PayloadAction<boolean>) => {
            state.showPrescriptionModalContinue = payload;
        },
        setOpenPrescriptionInputModal: (state,{payload}: PayloadAction<boolean>) => {
            state.openPrescriptionInputModal = payload;
        },
        setOpenLearnMoreModal: (state,{payload}: PayloadAction<string>) => {
            state.learnMoreFocus = payload;
        },
        setListLearnMoreModal: (state,{payload}: PayloadAction<string[]>) => {
            state.learnMoreIds= payload;
        },
    },
  });

export const modalsReducer = modalsSlice.reducer;
export const modalsActions = modalsSlice.actions;